module.exports = __webpack_public_path__ + "static/media/bgf.c09e886d.jpg";